module.exports = __webpack_public_path__ + "static/img/news_deteils.b278eb66.jpg";